import React, {  useEffect, useState } from 'react';
import { Input, message, Upload, UploadFile } from 'antd';
import { useStore } from '@/app/providers/StoreProvider';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { Loading } from '@/shared/ui/Loading';

import ImgTeamBorder from '@/shared/pictures/team_border.png';



export const TeamEditPage = observer(() => {
  const navigate = useNavigate();

  const [name,setName] = useState<string>('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [inputFocus,setInputFocus] = useState<boolean>(false);

  const {teamStore} = useStore();
  const {myTeam, getMyTeam, editTeam} = teamStore;

  useEffect(() => {
      if(!myTeam){
        getMyTeam();
      }
  }, [myTeam]);

  if(!myTeam || teamStore.loadingTeams) return <Loading/>


  const handleSearch = (e:React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }

  const handleChange = (info: { file: UploadFile; fileList: UploadFile[] }) => {
    const updated = info.fileList.map(file => {
      if (!file.preview && file.originFileObj) {
        file.preview = URL.createObjectURL(file.originFileObj);
      }
      return file;
    });
    setFileList(updated);
  };

  const maxSize = 10 * 1024 * 1024;
  const allowedTypes = [
      'image/jpeg',
      'image/png',
  ];

  const beforeUpload = async(file: File) => {
    if (!allowedTypes.includes(file.type)) {
      message.error('Формат изображения не поддерживается');
      return Upload.LIST_IGNORE;
    }
    if (file.size > maxSize) {
      message.error('Превышен размер изображения');
      return Upload.LIST_IGNORE;
    }
    return file;
  };

  const handleUpload = async () => {

    if (name === '') {
      message.error('Смените название команды');
      return;
    }
    if ((!fileList.length || !fileList[0].originFileObj) ) {
      await editTeam(name);
    }else{
      const file = fileList[0].originFileObj;
      const formData = new FormData();
      formData.append('file', file);
      await editTeam(name,formData);
    }
    navigate(`/team?id=${myTeam.id}`)
  };

  return (
    <div className='teamcreate-page'>
      <div className="container">
        <h1 className='teamcreate_title'>Редактирование команды</h1>
        <div className='teamcreate_file-block'>

        <div className='teamcreate_img-block'>
            {fileList.length > 0?

              fileList.map(file => (
                <div key={file.uid}>
                  <img className='teamcreate_img' src={file.preview} alt={file.name} key={file.uid}/>
                  <img className='teamcreate_border' src={ImgTeamBorder} alt="team-img"/>
                </div>
              ))
              :
              <div className='teamcreate_img-block'>
                <img className='teamcreate_img' src={myTeam.imageUrl} alt='team-img'/>
                <img className='teamcreate_border' src={ImgTeamBorder} alt="team-img"/>
              </div>
            }
        </div>
          <div className='teamcreate_file-info'>
            <h2 className='teamcreate_file-title'>Обновите эмблему своей <br/> будущей команды!</h2>
            <p className='teamcreate_file-text'>максимальный размер файла 10 МБ</p>
            <Upload
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              fileList={fileList}
              maxCount={1}
            >
              <div className="teamcreate_file-button">Загрузить</div>
            </Upload>
          </div>
        </div>

        <Input className={`teamcreate_input ${inputFocus?'absolute':''}`} placeholder="Введите название команды" onChange={handleSearch} value={name !== ''?name:myTeam.name} onFocus={()=>setInputFocus(true)} onBlur={()=>setInputFocus(false)}/>

        <div className='teamcreate_buttons'>
          <div className='teamcreate_button' onClick={()=>navigate(-1)}>Сбросить</div>
          <div className='teamcreate_button blue' onClick={()=>handleUpload()}>Сохранить изменения</div>
        </div>

    </div>
    </div>
  )
});
